import React from 'react';
import Template from './Template';

export default (props) => (
  <Template
    {...props}
    src="/Khoo.png"
    name="Khoo Khay Teik "
    position="Chief Operating Officer (COO)"
    description={(
      <div>
        <p>
          Khoo holds the position of COO at Premium Capital Partners, tasked with the critical role
          of risk management and oversight of operational efficiency. He brings with him more than
          30 years of management and accounting experience spanning a diverse range of industries
          from manufacturing to unit-trusts.
        </p>
        <p>
          Khoo has previously worked with mutual funds operating with more than RM10 billion under
          management, before moving on to spend the last 10 years undertaking specialist projects in
          corporate listings, change and production management, and support of C-suite level
          implementation of transformative business strategies.
        </p>
        <p>
          Khoo is keen to leverage his international operational experience to ensure Premium
          Capital Partners delivers outstanding business financing solutions that adapt to embrace
          the opportunities presented by evolving modern financial markets.
        </p>
      </div>
    )}
    quote="This isn't just a business built on the financial solutions we're offering today, but one driven by the ambition to embrace new ways of working, to continue to develop innovative financial products that meet the needs of modern business."
  />
)



// WEBPACK FOOTER //
// ./src/screens/OurTeam/Khoo.js